import _ from "lodash"

export const STATUS_LABELS: Record<string, string> = {
  awaiting_opt_in: "Awaiting Opt-In",
  opt_in_declined: "Opt-In Declined",
  opt_in_expired: "Opt-In Expired",
  delivery_unknown: "Delivery unknown",
}

export const formatStatus = (status: string) => STATUS_LABELS[status] ?? _.capitalize(status)
